import AuthForgotPassword from "./AuthForgotPassword";

export default AuthForgotPassword;
